import React from 'react';
import { NavigationItemMenuModel } from './navigationItem/models/navigationItem.model';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { useMenuItemWithContext } from '../menuContext';
import { NavigationItemTray } from './navigationItemMenu';
import Icon from '../../@shared/icon';

const NavigationAccordionItem = (props: { model: NavigationItemMenuModel; closeMainNavigation: () => void }) => {
  const [isOpen, setOpen] = useMenuItemWithContext();
  const handleClick = () => {
    setOpen(!isOpen);
  };
  const { model, closeMainNavigation } = props;
  const icon = isOpen ? 'arrow-chevron-up' : 'arrow-chevron-down';
  return (
    <li className="navigation__accordion-item">
      <button type="button" className="navigation__accordion-item__trigger" onClick={handleClick}>
        <RichText field={model.menuTitle} tag="span" />
        <Icon iconName={icon} extraClassName="navigation__accordion-item__trigger__icon" size={22} />
      </button>
      <div className="navigation__accordion-item__tray">
        {isOpen && <NavigationItemTray model={model} closeMainNavigation={closeMainNavigation} />}
      </div>
    </li>
  );
};

export default NavigationAccordionItem;
